import { TableCard } from '../../../../components'
import { ClienteHeading } from '../empresasCliente-list/components/ClienteHeading'
import { SetorClienteListHeader } from './components/header/SetorClienteListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { SetorClienteTable } from './table/SetorClienteTable'

const SetorClienteList = () => {
  return (
    <>
      <ClienteHeading />
      <TableCard>
        <SetorClienteListHeader />
        <SetorClienteTable />
      </TableCard>
    </>
  )
}

export const SetorClienteListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <SetorClienteList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
